import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Tooltip from "@material-ui/core/Tooltip";
//componentes
import "./nomina.css";
import Alert from "../../modal/alert";
import { fetchSedes } from "../../utils/sedesApi";
import ReporteN from "./reporteNominaE";
import ReporteN2 from "./reporteNominaE2";
import ReporteN3 from "./reporteNominaE3";
import Inasistencia from "./inasistencia/Inasistencia";

const esOpcionImpresionValida = (opcion) => {
  const op = parseInt(opcion, 10);
  return op >= 1 && op <= 3;
};

const OPCIONES_IMPRESION_REPORTE = [
  { value: "1", label: "Opción 1 (15 y 30)" },
  { value: "2", label: "Opción 2 (5 y 20)" },
  { value: "3", label: "Opción 3 (10 y 25)" },
];

const esOpcionImpresionConsultaValida = (opcion) => {
  const op = parseInt(opcion, 10);
  return op >= 1 && op <= 4;
};

const aplicarFiltroImpresionConsulta = (lista, opcion) => {
  if (!Array.isArray(lista)) return [];
  if (!opcion || String(opcion).trim() === "") return [];
  if (String(opcion) === "4") return lista;
  const op = parseInt(opcion, 10);
  if (op >= 1 && op <= 3) {
    return lista.filter((i) => parseInt(i.variable54, 10) === op);
  }
  return [];
};

/** Monto P. = saldo; P.Pres. = cuota editable si aún no hay pago en la nómina. */
const prepararFilasPrestamoNomina = (lista) => {
  if (!Array.isArray(lista)) return [];
  return lista.map((item) => {
    const row = { ...item };
    const deuda = parseFloat(row.variable16) || 0;
    const pagadoNomina = parseFloat(row.variable19) || 0;
    const cuota = parseFloat(row.variable24) || 0;
    const subtotal = parseFloat(row.variable11) || 0;
    if (deuda > 0 && pagadoNomina === 0) {
      const sugerido = cuota > 0 ? cuota : 0;
      const sugeridoTxt = Number.parseFloat(sugerido).toFixed(2);
      row.valorEntrada3 = sugeridoTxt;
      row.variable12 = sugerido;
      row.variable24 = sugeridoTxt;
      row.variable13 = Number.parseFloat(subtotal - sugerido).toFixed(2);
      row.prestamoEditable = true;
    } else {
      row.prestamoEditable = false;
    }
    return row;
  });
};

const esOpcionImpresionCrearValida = (opcion) => {
  const op = parseInt(opcion, 10);
  return op >= 1 && op <= 4;
};

const periodoCrearNominaLleno = (q, m, a) => {
  const quincenaOk = String(q) === "1" || String(q) === "2";
  const mesOk = String(m).trim() !== "" && String(m) !== "0";
  const anioOk = String(a).trim() !== "" && String(a) !== "0";
  return quincenaOk && mesOk && anioOk;
};

const OPCIONES_IMPRESION_CREAR = [
  ...OPCIONES_IMPRESION_REPORTE,
  { value: "4", label: "Opción 4 (Todas)" },
];

const nombresFaltantesVisibles = (lista, opcion) => {
  if (!Array.isArray(lista) || !opcion) return [];
  const op = String(opcion);
  const filas =
    op === "4"
      ? lista
      : lista.filter((item) => String(item.opcion) === op);
  const vistos = {};
  const nombres = [];
  filas.forEach((item) => {
    const nombre = item && item.nombre ? String(item.nombre).trim() : "";
    if (nombre && !vistos[nombre]) {
      vistos[nombre] = true;
      nombres.push(nombre);
    }
  });
  return nombres;
};

/** tipoContrato Operativo (5): rótulos CONTRATO POR HORA DEFINIDO / OPER. */
const esFilaOperativoNomina = (item) => {
  const r = String(item && item.variable30 != null ? item.variable30 : "").toUpperCase();
  if (r.indexOf("OPER") !== -1) return true;
  if (r.indexOf("CONTRATO POR HORA DEFINIDO") !== -1 && r.indexOf("ADM") === -1) {
    return true;
  }
  return false;
};

const hayDescuentoOperativoEnNomina = (lista) => {
  if (!Array.isArray(lista)) return false;
  return lista.some((item) => {
    if (!esFilaOperativoNomina(item)) return false;
    const dnt = parseFloat(item.variable5) || 0;
    const hnt = parseFloat(item.variable7) || 0;
    return dnt > 0 || hnt > 0;
  });
};

const TEXTO_REGLA_600_OPERATIVO =
  "Regla Operativo (ref. 600):\n> 600 → $25/día\n= 600 → $23/día\n< 600 → $19/día\nPor hora: monto del día ÷ horas diarias";

function NominaC(props) {
  const [listaOn, setlistaOn] = React.useState(false);
  const [prioridadOn, setprioridadOn] = React.useState(false);
  const [mensajealerta, setmensajealerta] = React.useState(false);
  const [activarOn, setactivarOn] = React.useState(false);
  const [cierreOn, setCierreOn] = React.useState(false);
  const [personal, setpersonal] = React.useState([]);
  const [anio, setanio] = React.useState([]);
  const [mes, setmes] = React.useState([]);
  const [desde, setDesde] = React.useState([]);
  const [hasta, setHasta] = React.useState([]);
  const [cuenta, setcuenta] = React.useState([]);
  const [nominaPersonal, setnominaPersonal] = React.useState([]);
  const [nominaPersonalTodos, setnominaPersonalTodos] = React.useState([]);
  const [diaImpresionReporteConsulta, setDiaImpresionReporteConsulta] =
    React.useState("");
  const [tipoNomina, settipoNomina] = React.useState(0);
  const [totalPrioridad, settotalPrioridad] = React.useState(0);
  const [totalPrioridadPP, settotalPrioridadPP] = React.useState(0);
  const [totalPrioridadPagada, settotalPrioridadPagada] = React.useState(0);
  const [salarioB, setsalarioB] = React.useState(0);
  const [montosso, setmontosso] = React.useState(0);
  const [montose, setmontose] = React.useState(0);
  const [subtotal, setsubtotal] = React.useState(0);
  const [pagoprestamo, setpagoprestamo] = React.useState(0);
  const [totalapagar, settotalapagar] = React.useState(0);
  const [islr, setislr] = React.useState(0);
  const [montoQuincena, setmontoQuincena] = React.useState(0);
  const [salarioD, setsalarioD] = React.useState(0);
  const [ssoP, setssoP] = React.useState(0);
  const [seguroE, setseguroE] = React.useState(0);
  const [xislr, setxislr] = React.useState(0);
  const [cuentaContable, setcuentaContable] = React.useState("");
  const [sede, setSede] = React.useState("");
  const [sedes, setSedes] = React.useState([]);
  const [quincena, setquincena] = React.useState("");
  const [anopagar, setanopagar] = React.useState("");
  const [mesapagar, setmesapagar] = React.useState("");
  const [openvio, setopenvio] = React.useState("");
  const [flotadorNOn, setflotadorNOn] = React.useState(false);
  const [flotador2NOn, setflotador2NOn] = React.useState(false);
  const [flotador3NOn, setflotador3NOn] = React.useState(false);
  const [flotador4NOn, setflotador4NOn] = React.useState(false);
  const [ocultarOn, setocultarOn] = React.useState(true);
  const [asistenciaOn, setAsistenciaOn] = React.useState(false);
  const [deducOn, setDdeducOn] = React.useState(false);
  const [cierreQuinOn, setCierreQuinOn] = React.useState(false);
  const [cierreQui, setCierreQui] = React.useState([]);
  const [flotadorInasistenciaOn, setflotadorInasistenciaOn] = React.useState(false);
  const [reporteSeleccionado, setReporteSeleccionado] = React.useState("");
  const [comprobantesOn, setComprobantesOn] = React.useState(false);
  const [tipoNominaComprobante, setTipoNominaComprobante] = React.useState("");
  const [sedeComprobante, setSedeComprobante] = React.useState("");
  const [empleadoComprobante, setEmpleadoComprobante] = React.useState("");
  const [nominaPersonalComprobantes, setNominaPersonalComprobantes] = React.useState([]);
  const [diaImpresionReporte, setDiaImpresionReporte] = React.useState("");
  const [diaImpresionCrearNomina, setDiaImpresionCrearNomina] =
    React.useState("");
  const [faltantesNominaTodos, setFaltantesNominaTodos] = React.useState([]);

  const [data, setData] = React.useState({
    cedulaNomina: "",
    diasTrabajado: "",
    montoDescontarP: 0,
    saldoPrestamo: "",
    deducciones: "",
  });
  const [tituloM, settituloM] = React.useState("");
  const [cuerpoM, setcuerpoM] = React.useState("");

  const onChangeReporte = (e) => {
    const valor = e.target.value;
    setReporteSeleccionado(valor);
    if (valor && !activarOn) {
      ejecutarReporteConValor(valor);
      setReporteSeleccionado("");
    }
  };

  /** Opción 1-3: prioriza la de Consultar Nomina; si no, la de Reportes. */
  const opcionImpresionParaReporte = () => {
    if (esOpcionImpresionValida(diaImpresionReporteConsulta)) {
      return String(diaImpresionReporteConsulta);
    }
    if (esOpcionImpresionValida(diaImpresionReporte)) {
      return String(diaImpresionReporte);
    }
    return "";
  };

  const validarDiaImpresionReporte = () => {
    if (!esOpcionImpresionValida(opcionImpresionParaReporte())) {
      setmensajealerta(true);
      settituloM("Reportes de nómina.");
      setcuerpoM(
        "Debe seleccionar una opción de impresión (Opción 1, 2 o 3) en Consultar o en Imprimir."
      );
      return false;
    }
    return true;
  };

  const ejecutarReporteConValor = (valor) => {
    if (
      valor === "reporteQuincenal" ||
      valor === "reporteQuincenalPago" ||
      valor === "reportePrioridadPago" ||
      valor === "reporteDatosBancarios" ||
      valor === "reporteCuadreNomina"
    ) {
      if (!validarDiaImpresionReporte()) {
        return;
      }
    }
    switch (valor) {
      case "reporteQuincenal":
        activarReporte2();
        break;
      case "reporteQuincenalPago":
        activarReporte3();
        break;
      case "reportePrioridadPago":
        activarReporte4();
        break;
      case "reporteDatosBancarios":
        datosBanco();
        break;
      case "reporteSipe":
        registroContable();
        break;
      case "reporteSipeNuevo":
        reporteSipeNuevoExcel();
        break;
      case "reporteSalarioAcumulado":
        reporteSalarioAcumulado();
        break;
      case "reporteEmplCodContable":
        empleadoCodigoContable();
        break;
      case "reporteEmplCorreo":
        empleadoCorreos();
        break;
      case "reporteEmplSalario":
        empleadoCorreos2();
        break;
      case "reporteColaboradoresContrato":
        colaboradoresContrato();
        break;
      case "reporteEmplSalarioExcel":
        empleadoSalarioExcel();
        break;
      case "reporteAsistenciaExcel":
        asistencia();
        break;
      case "reporteDeduccionesExcel":
        deduc();
        break;
      case "reporteCuadreNomina":
        cuadreNomina();
        break;
      default:
        break;
    }
  };

  const limpiar = () => {
    setsalarioB(0);
    setmontosso(0);
    setmontose(0);
    setsubtotal(0);
    settotalPrioridad(0);
    settotalPrioridadPP(0);
    settotalPrioridadPagada(0);
    setpagoprestamo(0);
    settotalapagar(0);
    setislr(0);
    setmontoQuincena(0);
    setSede("");
    setDiaImpresionReporteConsulta("");
    setDiaImpresionCrearNomina("");
    setnominaPersonalTodos([]);
    setnominaPersonal([]);
    setmensajealerta(false);
    setactivarOn(false);
    setsalarioB(0);
    setDesde("");
    setHasta("");
    let data_ = Object.assign({}, data);
    data_ = {
      montoDescontarP: 0,
      cedulaNomina: 0,
    };
    setData(data_);
  };

  const cerrarLista = () => {
    //console.log(listaOn)
    if (listaOn) {
      setlistaOn(false);
    } else {
      setlistaOn(true);
      buscarNomina();
    }
    //console.log(listaOn);
  };
  const cerrarPrioridad = () => {
    //console.log(listaOn)
    if (prioridadOn) {
      setprioridadOn(false);
    } else {
      setprioridadOn(true);
      buscarNomina();
    }
    //console.log(listaOn);
  };

  const onChange1 = (e) => {
    //console.log(e.target.name)
    setDesde(e.target.value);
    //console.log(e.target.value)
  };
  const onChange2 = (e) => {
    //console.log(e.target.name)
    setHasta(e.target.value);
    //console.log(e.target.value)
  };

  const onChange = (e) => {
    let index = e.target.getAttribute("id");
    // console.log (e.target);
    // console.log(index)
    let data_ = Object.assign({}, data);
    data_[index] = e.target.value;
    setData(data_);

    if (index === "sede") {
      setSede(e.target.value);
      if (e.target.value) {
        buscarNomina(e.target.value);
      } else {
        setnominaPersonal([]);
        setnominaPersonalTodos([]);
      }
    }
    if (index === "quincena") {
      setquincena(e.target.value);
      limpiar();
    }
    if (index === "anopagar") {
      setanopagar(e.target.value);
      limpiar();
    }
    if (index === "mesapagar") {
      setmesapagar(e.target.value);
      limpiar();
    }
    if (index === "cuentaotrosEgresos") {
      setcuentaContable(e.target.value);
      limpiar();
    }
  };

  const onChange6 = (index, value) => {
    let nominaP_ = Array.from(nominaPersonal);
    // nominaP_[index].cuentaContable = 0;
    nominaP_[index].variable35 = value;
    setnominaPersonal(nominaP_);
  };

  const onChange4 = (e, f) => {
    let form = new FormData();
    form.append("cedulaT", e);
    form.append("idnomina", f);
    form.append("quincena", quincena);
    form.append("mesapagar", mesapagar);
    form.append("anopagar", anopagar);
    form.append("boton", "guardarPri");
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/nomina2.php";
    axios
      .post(xurl, form, config)

      .then((res) => {
        if (res.data.variable1) {
          buscarNomina();
        } else {
          // this.setState({});
        }
      });
    //console.log({"copia:":listaCorreo_, "global":listaCorreo})
  };

  const onChange5 = (e, f) => {
    let form = new FormData();
    form.append("cedulaT", e);
    form.append("idnomina", f);
    form.append("quincena", quincena);
    form.append("mesapagar", mesapagar);
    form.append("anopagar", anopagar);
    form.append("boton", "guardarPriPago");
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/nomina2.php";
    axios
      .post(xurl, form, config)

      .then((res) => {
        if (res.data.variable1) {
          buscarNomina();
        } else {
          // this.setState({});
        }
      });
    //console.log({"copia:":listaCorreo_, "global":listaCorreo})
  };
  const handleClose = () => {
    setmensajealerta(false);
  };

  const mostrarAlertaFaltantes = (lista, opcion) => {
    const faltan = nombresFaltantesVisibles(lista, opcion);
    if (faltan.length === 0) {
      return false;
    }
    setmensajealerta(true);
    settituloM("Trabajadores no incluidos en la nómina.");
    setcuerpoM(
      "Hay colaboradores que deberían estar en esta quincena y no están: " +
        faltan.join(", ") +
        ". Puede incluirlos con Adicionar Trabajador a la Nomina."
    );
    return true;
  };

  const onChangeImpresionConsulta = (e) => {
    const valor = e.target.value;
    setDiaImpresionReporteConsulta(valor);
    setnominaPersonal(aplicarFiltroImpresionConsulta(nominaPersonalTodos, valor));
    if (!mostrarAlertaFaltantes(faltantesNominaTodos, valor)) {
      setmensajealerta(false);
    }
  };

  const validarConsultaNominaCreada = () => {
    if (!sede || String(sede).trim() === "") {
      setmensajealerta(true);
      settituloM("Menu Generar Nomina.");
      setcuerpoM("Seleccione una sede.");
      return false;
    }
    if (!esOpcionImpresionConsultaValida(diaImpresionReporteConsulta)) {
      setmensajealerta(true);
      settituloM("Menu Generar Nomina.");
      setcuerpoM("Seleccione una opción de impresión.");
      return false;
    }
    if (nominaPersonal.length === 0) {
      setmensajealerta(true);
      settituloM("Menu Generar Nomina.");
      setcuerpoM("No hay empleados para la sede y opción de impresión seleccionadas.");
      return false;
    }
    return true;
  };

  const buscarNomina = (e) => {
    let sedeConsulta = sede;
    if (e !== undefined && e !== null && String(e) !== "") {
      sedeConsulta = String(e);
    }
    if (!sedeConsulta || String(sedeConsulta).trim() === "") {
      setnominaPersonal([]);
      setnominaPersonalTodos([]);
      setFaltantesNominaTodos([]);
      return;
    }
    let form = new FormData();
    form.append("quincena", quincena);
    form.append("mesapagar", mesapagar);
    form.append("anoapagar", anopagar);
    form.append("openvio", openvio);
    form.append("sede", sedeConsulta);
    form.append("boton", "buscarNomina");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
    axios.post(xurl, form, config).then((res) => {
      if (res.data.variable1) {
        let xnominaPersonal = prepararFilasPrestamoNomina(res.data.variable2);
        setnominaPersonalTodos(xnominaPersonal);
        setnominaPersonal(
          aplicarFiltroImpresionConsulta(xnominaPersonal, diaImpresionReporteConsulta)
        );
        settotalPrioridad(res.data.variable3);
        settotalPrioridadPP(res.data.variable4);
        settotalPrioridadPagada(res.data.variable5);
        if (res.data.variable6===1){
          setCierreOn(true);
        }else{
          setCierreOn(false);
        }
        const faltan = Array.isArray(res.data.variable7) ? res.data.variable7 : [];
        setFaltantesNominaTodos(faltan);
        mostrarAlertaFaltantes(faltan, diaImpresionReporteConsulta);
      } else {
        let xnominaPersonal = prepararFilasPrestamoNomina(res.data.variable2);
        setnominaPersonalTodos(xnominaPersonal);
        setnominaPersonal(
          aplicarFiltroImpresionConsulta(xnominaPersonal, diaImpresionReporteConsulta)
        );
        setFaltantesNominaTodos([]);
        setmensajealerta(true);
        settituloM("Menu Generar Nomina.");
        setcuerpoM(res.data.variable3);
      }
    });
  };

  const buscarPrestamo = async (e) => {
    if (quincena.length > 0) {
      if (mesapagar.length > 0) {
        if (anopagar.length > 0) {
          if (e.target.value.length > 0) {
            limpiar();
            let rcedu = e.target.value;
            let form = new FormData();
            form.append("cedulaEmpleado", e.target.value);
            form.append("boton", "saldoPrestamo");
            let config = {
              headers: { "Content-Type": "text/html" },
            };
            const xurl =
              "https://institutobilinguelasnaciones.com/terapias/backend/prestamo.php";
            let res = await axios.post(xurl, form, config);
            let data_ = Object.assign({}, data);
            data_["saldoPrestamo"] = Number.parseFloat(
              res.data.variable1
            ).toFixed(2);
            data_["cedulaNomina"] = rcedu;
            setData(data_);
            settipoNomina(res.data.variable2);
            buscarDatosNomina(rcedu);
          }
        } else {
          setmensajealerta(true);
          settituloM("Menu Generar Nomina.");
          setcuerpoM("Debe elegir un Año, Gracias");
        }
      } else {
        setmensajealerta(true);
        settituloM("Menu Generar Nomina.");
        setcuerpoM("Debe elegir un Mes, Gracias");
      }
    } else {
      setmensajealerta(true);
      settituloM("Menu Generar Nomina.");
      setcuerpoM("Debe elegir una Quincena, Gracias");
    }
  };

  const buscarPersonal = () => {
    let form = new FormData();
    form.append("dedonde", "crearNomina");
    form.append("nivel", props.usuario1.nivel);
    form.append("sede", props.usuario1.sede);
    form.append("boton", "buscarPersonal");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
    axios.post(xurl, form, config).then((res) => {
      let xpersonal = res.data.variable1;
      setpersonal(xpersonal);
    });
  };

  const actualizarNomina = () => {
    if (quincena.length > 0) {
      if (mesapagar.length > 0) {
        if (anopagar.length > 0) {
          if (!validarConsultaNominaCreada()) {
            return;
          }
          let data = new FormData();
          data.append("quincena", quincena);
          data.append("mesapagar", mesapagar);
          data.append("anoapagar", anopagar);
          data.append("arregloNomina", JSON.stringify(nominaPersonal));
          data.append("boton", "modificarNomina");
          let config = {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };
          const xurl =
            "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
          axios
            .post(xurl, data, config)

            .then((res) => {
              if (res.data.variable1) {
                buscarNomina();
                setmensajealerta(true);
                settituloM("Menu Nomina.");
                setcuerpoM(res.data.variable2);
              } else {
                setmensajealerta(true);
                settituloM("Menu Nomina.");
                setcuerpoM(res.data.variable2);
              }
            });
        } else {
          setmensajealerta(true);
          settituloM("Menu Generar Nomina.");
          setcuerpoM("Debe elegir un Año, Gracias");
        }
      } else {
        setmensajealerta(true);
        settituloM("Menu Generar Nomina.");
        setcuerpoM("Debe elegir un Mes, Gracias");
      }
    } else {
      setmensajealerta(true);
      settituloM("Menu Generar Nomina.");
      setcuerpoM("Debe elegir una Quincena, Gracias");
    }
  };

  const guardarNomina = () => {
    if (quincena.length > 0 && mesapagar.length > 0 && anopagar.length > 0) {
      if (!esOpcionImpresionCrearValida(diaImpresionCrearNomina)) {
        setmensajealerta(true);
        settituloM("Menu Generar Nomina.");
        setcuerpoM("Debe seleccionar el tipo de pago (opción 1, 2, 3 o 4).");
        return;
      }
      let form = new FormData();
      // form.append("cedula", data.cedulaNomina);
      // form.append("diasTrabajado", data.diasTrabajado);
      // form.append("salarioB", salarioB);
      // form.append("montosso", montosso);
      // form.append("montose", montose);
      // form.append("subtotal", subtotal);
      // form.append("islr", islr);
      // form.append("pagoprestamo", pagoprestamo);
      // form.append("totalapagar", totalapagar);
      form.append("quincena", quincena);
      form.append("mesapagar", mesapagar);
      form.append("anoapagar", anopagar);
      form.append("openvio", openvio);
      form.append("diaImpresionReporte", diaImpresionCrearNomina);
      form.append("boton", "guardarNomina");
      let config = {
        headers: { "Content-Type": "text/html" },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/nomina2.php";
      axios.post(xurl, form, config).then((res) => {
        //console.log(res.data.variable1);
        //console.log(res.data.variable2);
        if (res.data.variable1) {
          setmensajealerta(true);
          settituloM("Menu Generar Nomina.");
          setcuerpoM(res.data.variable2);
        } else {
          setmensajealerta(true);
          settituloM("Menu Generar Nomina.");
          setcuerpoM(res.data.variable2);
        }
      });
    } else {
      setmensajealerta(true);
      settituloM("Menu Generar Nomina.");
      setcuerpoM("Debe existir una Quincena, Mes y Año a Pagar");
    }
  };

  const guardarNominaInd = () => {
    if (
      quincena.length > 0 &&
      mesapagar.length > 0 &&
      anopagar.length > 0 &&
      data.cedulaNomina.length > 0
    ) {
      let form = new FormData();
      form.append("cedulaPersonal", data.cedulaNomina);
      form.append("quincena", quincena);
      form.append("mesapagar", mesapagar);
      form.append("anoapagar", anopagar);
      form.append("openvio", openvio);
      form.append("boton", "guardarNominaInd");
      let config = {
        headers: { "Content-Type": "text/html" },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/nomina2.php";
      axios.post(xurl, form, config).then((res) => {
        //console.log(res.data.variable1);
        //console.log(res.data.variable2);
        if (res.data.variable1) {
          setflotador2NOn(false);
          setmensajealerta(true);
          buscarNomina();
          settituloM("Menu Generar Nomina.");
          setcuerpoM(res.data.variable2);
        } else {
          setmensajealerta(true);
          settituloM("Menu Generar Nomina.");
          setcuerpoM(res.data.variable2);
        }
      });
    } else {
      setmensajealerta(true);
      settituloM("Menu Generar Nomina.");
      setcuerpoM("Debe existir una Quincena, Mes y Año a Pagar");
    }
  };

  const consultaRecibo = (e) => {
    if (e.length > 0) {
      let data = new FormData();
      data.append("idnomina", e);
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reciboEmpleados.php",
        responseType: "arraybuffer",
        data: data,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
  };

  const reporteMensual = (e) => {
    if (e.length > 0) {
      let data = new FormData();
      data.append("idnomina", e);
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reciboEmpleados.php",
        responseType: "arraybuffer",
        data: data,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
  };

  const eliminarEmpleado = () => {
    if (data.cedula.length > 0) {
      let form = new FormData();
      form.append("cedula", data.cedula);
      form.append("boton", "eliminarEmpleado");
      let config = {
        headers: { "Content-Type": "text/html" },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
      axios.post(xurl, form, config).then((res) => {
        //console.log(res.data.variable4);
        //console.log(res.data.variable3);
        if (res.data.variable1) {
          limpiar();
          setmensajealerta(true);
          settituloM("Menu Empleado.");
          setcuerpoM(res.data.variable2);
        } else {
          setmensajealerta(true);
          settituloM("Menu Empleado.");
          setcuerpoM(res.data.variable2);
        }
      });
    }
  };

  const buscarDatosNomina = (e) => {
    let form = new FormData();
    form.append("quincena", quincena);
    form.append("mesapagar", mesapagar);
    form.append("anoapagar", anopagar);
    form.append("cedulaNomina", e);
    form.append("boton", "buscarDatosNomina");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
    axios.post(xurl, form, config).then((res) => {
      setsalarioD(parseFloat(res.data.variable1));
      setssoP(parseFloat(res.data.variable2));
      setseguroE(parseFloat(res.data.variable4));
    });
  };

  const calcular = () => {
    //console.log(data.cedulaNomina);
    if (data.cedulaNomina.length > 1) {
      if (quincena.length > 0) {
        if (mesapagar.length > 0) {
          if (anopagar.length > 0) {
            if (parseFloat(data.diasTrabajado) > 0) {
              let xislr = 0;
              //buscarDatosNomina(data.cedulaNomina);

              // console.log(ssoP);
              // console.log(seguroE);
              let hsalaB = 0;
              hsalaB = salarioD * data.diasTrabajado;
              setsalarioB(Number.parseFloat(hsalaB).toFixed());
              //console.log(salarioD);
              //console.log(hsalaB);

              if (tipoNomina === "1" || tipoNomina === "2") {
                let hsso = 0;
                hsso = (ssoP * (salarioD * data.diasTrabajado)) / 100;
                setmontosso(Number.parseFloat(hsso).toFixed(2));

                let hsse = 0;
                hsse = (seguroE * (salarioD * data.diasTrabajado)) / 100;
                setmontose(Number.parseFloat(hsse).toFixed(2));
                let hislr = 0;
                //console.log(xislr);
                if (hsalaB >= 424) {
                  hislr = ((hsalaB - 423.07) * 15) / 100;
                  //console.log(hislr);
                  setislr(Number.parseFloat(hislr).toFixed(2));
                }
                let subt = 0;
                subt = hsalaB - hsso - hsse - hislr;
                setsubtotal(Number.parseFloat(subt).toFixed());

                if (data.montoDescontarP.length > 0) {
                  setpagoprestamo(
                    Number.parseFloat(data.montoDescontarP).toFixed(2)
                  );
                } else {
                  setpagoprestamo("0");
                }
                let htotal = subt - data.montoDescontarP;
                settotalapagar(Number.parseFloat(htotal).toFixed());
              }
              if (tipoNomina > 2) {
                setsubtotal(
                  Number.parseFloat(salarioD * data.diasTrabajado).toFixed()
                );

                if (data.montoDescontarP.length > 0) {
                  setpagoprestamo(
                    Number.parseFloat(data.montoDescontarP).toFixed(2)
                  );
                } else {
                  setpagoprestamo("0");
                }

                settotalapagar(
                  Number.parseFloat(
                    salarioD * data.diasTrabajado - data.montoDescontarP
                  ).toFixed()
                );
              }
            } else {
              setmensajealerta(true);
              settituloM("Menu Generar Nomina.");
              setcuerpoM(
                "Debe Indicar los Días Trabajados del Empleado, Gracias"
              );
            }
          } else {
            setmensajealerta(true);
            settituloM("Menu Generar Nomina.");
            setcuerpoM("Debe elegir un Año, Gracias");
          }
        } else {
          setmensajealerta(true);
          settituloM("Menu Generar Nomina.");
          setcuerpoM("Debe elegir un Mes, Gracias");
        }
      } else {
        setmensajealerta(true);
        settituloM("Menu Generar Nomina.");
        setcuerpoM("Debe elegir una Quincena, Gracias");
      }
    } else {
      setmensajealerta(true);
      settituloM("Menu Generar Nomina.");
      setcuerpoM("Debe elegir un Empleado, Gracias");
    }
  };

  const cargarFechas = () => {
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/fecha.php";
    axios.post(xurl).then((res) => {
      if (res.data.variable1) {
        let xmes = res.data.variable1;
        let xanio = res.data.variable2;
        //let xdia = res.data.variable3;
        //dia: xdia,
        setmes(xmes);
        setanio(xanio);
      }
    });
  };
  const eliminarNomina = (e) => {
    let form = new FormData();
    form.append("idnomina", e);
    form.append("boton", "eliminarNomina");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
    axios.post(xurl, form, config).then((res) => {
      if (res.data.variable1) {
        setmensajealerta(true);
        settituloM("Menu Nomina.");
        setcuerpoM(res.data.variable2);
        buscarNomina();
      } else {
        setmensajealerta(true);
        settituloM("Menu Nomina.");
        setcuerpoM(res.data.variable2);
      }
    });
  };

  const nombreSedeNomina = () => {
    if (sede === "0" || sede === 0) return "Todas las sucursales";
    const item = sedes.find((s) => String(s.variable1) === String(sede));
    return item ? item.variable2 : "la sucursal seleccionada";
  };

  const nombreOpcionImpresionConsulta = () => {
    if (String(diaImpresionReporteConsulta) === "4") {
      return "Opción 4 (Todas)";
    }
    const item = OPCIONES_IMPRESION_REPORTE.find(
      (op) => op.value === String(diaImpresionReporteConsulta)
    );
    return item ? item.label : "la opción seleccionada";
  };

  const eliminarQuincenaNomina = () => {
    let form = new FormData();
    form.append("quincena", quincena);
    form.append("mesapagar", mesapagar);
    form.append("anoapagar", anopagar);
    form.append("sede", sede);
    form.append("arregloNomina", JSON.stringify(nominaPersonal));
    form.append("boton", "eliminarQuincenaNomina");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
    axios.post(xurl, form, config).then((res) => {
      setmensajealerta(true);
      settituloM("Menu Nomina.");
      setcuerpoM(res.data.variable2);
      if (res.data.variable1) {
        buscarNomina();
      }
    });
  };

  const confirmarEliminarQuincena = () => {
    if (quincena.length === 0) {
      setmensajealerta(true);
      settituloM("Menu Generar Nomina.");
      setcuerpoM("Debe elegir una Quincena, Gracias");
      return;
    }
    if (mesapagar.length === 0) {
      setmensajealerta(true);
      settituloM("Menu Generar Nomina.");
      setcuerpoM("Debe elegir un Mes, Gracias");
      return;
    }
    if (anopagar.length === 0) {
      setmensajealerta(true);
      settituloM("Menu Generar Nomina.");
      setcuerpoM("Debe elegir un Año, Gracias");
      return;
    }
    if (!validarConsultaNominaCreada()) {
      return;
    }
    const textoSede = nombreSedeNomina();
    const textoOpcion = nombreOpcionImpresionConsulta();
    const msg =
      "¿Eliminar la nomina visible de la " +
      quincena +
      " Quincena " +
      mesapagar +
      "-" +
      anopagar +
      " (" +
      textoSede +
      ", " +
      textoOpcion +
      ", " +
      nominaPersonal.length +
      " empleado(s))? Esta accion no se puede deshacer.";
    if (window.confirm(msg)) {
      eliminarQuincenaNomina();
    }
  };

  const cargarCuentas = () => {
    let form = new FormData();
    form.append("boton", "buscarCodigosContablesAsientos");
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/contabilidad.php";
    axios.post(xurl, form, config).then((res) => {
      //console.log("paso "+res.data.variable2)
      setcuenta(res.data.variable1);
    });
  };
  const activarReporte2 = () => {
    if (flotadorNOn) {
      setflotadorNOn(false);
    } else {
      setflotadorNOn(true);
    }
  };
  const activarReporte3 = () => {
    if (flotador3NOn) {
      setflotador3NOn(false);
    } else {
      setflotador3NOn(true);
    }
  };
  const activarReporte4 = () => {
    if (flotador4NOn) {
      setflotador4NOn(false);
    } else {
      setflotador4NOn(true);
    }
  };

  const activarInasistencia = () => {
    if (flotadorInasistenciaOn) {
      setflotadorInasistenciaOn(false);
    } else {
      setflotadorInasistenciaOn(true);
    }
  };

  const abrirComprobantes = () => {
    if (!quincena || !mesapagar || !anopagar) {
      setmensajealerta(true);
      settituloM("Imprimir comprobantes de pago.");
      setcuerpoM("Debe indicar Quincena, Mes y Año a pagar.");
      return;
    }
    setTipoNominaComprobante("");
    setSedeComprobante("");
    setEmpleadoComprobante("");
    setNominaPersonalComprobantes([]);
    setComprobantesOn(true);
  };

  const cerrarComprobantes = () => {
    setComprobantesOn(false);
    setTipoNominaComprobante("");
    setSedeComprobante("");
    setEmpleadoComprobante("");
    setNominaPersonalComprobantes([]);
  };

  const onChangeTipoNominaComprobante = (e) => {
    const valor = e.target.value;
    setTipoNominaComprobante(valor);
    setSedeComprobante("");
    setEmpleadoComprobante("");
    setNominaPersonalComprobantes([]);
  };

  const cargarEmpleadosComprobantes = (sedeVal) => {
    let form = new FormData();
    form.append("quincena", quincena);
    form.append("mesapagar", mesapagar);
    form.append("anoapagar", anopagar);
    form.append("openvio", openvio);
    form.append("sede", sedeVal >= 1 && sedeVal <= 4 ? sedeVal : sede);
    form.append("boton", "buscarNomina");
    let config = { headers: { "Content-Type": "text/html" } };
    const xurl = "https://institutobilinguelasnaciones.com/terapias/backend/nomina.php";
    axios.post(xurl, form, config).then((res) => {
      let list = res.data.variable2 || [];
      if (tipoNominaComprobante === "sinHonorarios") {
        list = list.filter((i) => String(i.variable37) !== "3");
      } else if (tipoNominaComprobante === "conHonorarios") {
        list = list.filter((i) => String(i.variable37) === "3");
      }
      const opcion = parseInt(diaImpresionReporte, 10);
      if (opcion >= 1 && opcion <= 3) {
        list = list.filter((i) => parseInt(i.variable54, 10) === opcion);
      }
      setNominaPersonalComprobantes(list);
    }).catch(() => {
      setNominaPersonalComprobantes([]);
    });
  };

  const onChangeSedeComprobante = (e) => {
    const valor = e.target.value;
    setSedeComprobante(valor);
    setEmpleadoComprobante("");
    if (valor) {
      cargarEmpleadosComprobantes(valor);
    } else {
      setNominaPersonalComprobantes([]);
    }
  };

  const imprimirComprobantes = () => {
    if (!validarDiaImpresionReporte()) {
      return;
    }
    if (!tipoNominaComprobante) {
      setmensajealerta(true);
      settituloM("Imprimir comprobantes de pago.");
      setcuerpoM("Debe seleccionar el Tipo de nómina.");
      return;
    }
    if (!sedeComprobante) {
      setmensajealerta(true);
      settituloM("Imprimir comprobantes de pago.");
      setcuerpoM("Debe seleccionar la Sede.");
      return;
    }
    let data = new FormData();
    data.append("tipoNomina", tipoNominaComprobante);
    data.append("sede", sedeComprobante);
    data.append("quincena", quincena);
    data.append("mes", mesapagar);
    data.append("anio", anopagar);
    data.append("diaImpresionReporte", diaImpresionReporte);
    if (empleadoComprobante && empleadoComprobante !== "todos") {
      data.append("cedulaPersonal", empleadoComprobante);
    }
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/comprobanteEmpleado.php",
      responseType: "arraybuffer",
      data: data,
    })
      .then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      })
      .catch(() => {
        setmensajealerta(true);
        settituloM("Imprimir comprobantes de pago.");
        setcuerpoM("No se pudo generar el comprobante.");
      });
  };

  const adicionarTra = () => {
    if (flotador2NOn) {
      setflotador2NOn(false);
    } else {
      setflotador2NOn(true);
    }
  };

  const ocultarCuentas = () => {
    if (ocultarOn) {
      setocultarOn(false);
    } else {
      setocultarOn(true);
    }
  };

  const aplicarSubtotalYTotalNeto = (row) => {
    const v3 = parseFloat(row.variable3) || 0;
    const v38 = parseFloat(row.variable38) || 0;
    const v40 = parseFloat(row.variable40) || 0;
    const v5 = parseFloat(row.variable5) || 0;
    const v7 = parseFloat(row.variable7) || 0;
    const v34 = parseFloat(row.variable34) || 0;
    const v8 = parseFloat(row.variable8) || 0;
    const v9 = parseFloat(row.variable9) || 0;
    const v10 = parseFloat(row.variable10) || 0;
    const v12 = parseFloat(row.variable12) || 0;
    row.variable11 = (v3 + v38 + v40 - v5 - v7 - v34 - v8 - v9 - v10).toFixed(2);
    row.variable13 = (parseFloat(row.variable11) - v12).toFixed(2);
  };

  const calcularSumaValorEntrada1 = (
    index,
    value,
    diasNT,
    ssop,
    seduP,
    tipoNo
  ) => {
    let nominaP_ = Array.from(nominaPersonal);
    nominaP_[index].valorEntrada1 = value;
    // console.log(parseFloat(value))
    // console.log(nominaP_[index].valorEntrada1)
    // console.log(diasNT)
    // console.log(nominaP_[index].variable5)
    nominaP_[index].variable5 = parseFloat(value * diasNT).toFixed(2);

    nominaP_[index].variable8 = parseFloat(
      ((nominaP_[index].variable3 -
        nominaP_[index].variable5 -
        nominaP_[index].variable7 -
        nominaP_[index].variable34) *
        ssop) /
        100
    ).toFixed(2);
    nominaP_[index].variable9 = parseFloat(
      ((nominaP_[index].variable3 -
        nominaP_[index].variable5 -
        nominaP_[index].variable7 -
        nominaP_[index].variable34) *
        seduP) /
        100
    ).toFixed(2);
    //console.log(tipoNo)
    if (tipoNo.substring(0, 4) !== "HONO") {
      //console.log(tipoNo)
      if (
        nominaP_[index].variable3 -
          nominaP_[index].variable5 -
          nominaP_[index].variable7 -
          nominaP_[index].variable34 >=
        424
      ) {
        nominaP_[index].variable10 = parseFloat(
          ((nominaP_[index].variable3 -
            nominaP_[index].variable5 -
            nominaP_[index].variable7 -
            nominaP_[index].variable34 -
            423.07) *
            15) /
            100
        ).toFixed(2);
      } else {
        nominaP_[index].variable10 = 0;
      }
    }

    aplicarSubtotalYTotalNeto(nominaP_[index]);
    setnominaPersonal(nominaP_);
  };

  const calcularSumaValorEntrada2 = (
    index,
    value,
    horasNT,
    ssop,
    seduP,
    tipoNo
  ) => {
    let nominaP_ = Array.from(nominaPersonal);
    nominaP_[index].valorEntrada2 = 0;
    nominaP_[index].valorEntrada2 = value;
    //  console.log(parseFloat(value))
    //  console.log(nominaP_[index].valorEntrada2)
    //  console.log(horasNT)
    // console.log(nominaP_[index].variable2);
    if (parseFloat(value) === 0) value = 0;
    nominaP_[index].variable7 = parseFloat(value * horasNT).toFixed(2);

    nominaP_[index].variable8 = parseFloat(
      ((nominaP_[index].variable3 -
        nominaP_[index].variable5 -
        nominaP_[index].variable7 -
        nominaP_[index].variable34) *
        ssop) /
        100
    ).toFixed(2);
    nominaP_[index].variable9 = parseFloat(
      ((nominaP_[index].variable3 -
        nominaP_[index].variable5 -
        nominaP_[index].variable7 -
        nominaP_[index].variable34) *
        seduP) /
        100
    ).toFixed(2);

    if (tipoNo.substring(0, 4) !== "HONO") {
      if (
        nominaP_[index].variable3 -
          nominaP_[index].variable5 -
          nominaP_[index].variable7 -
          nominaP_[index].variable34 >=
        424
      ) {
        nominaP_[index].variable10 = parseFloat(
          ((nominaP_[index].variable3 -
            nominaP_[index].variable5 -
            nominaP_[index].variable7 -
            nominaP_[index].variable34 -
            423.07) *
            15) /
            100
        ).toFixed(2);
      } else {
        nominaP_[index].variable10 = 0;
      }
    }
    aplicarSubtotalYTotalNeto(nominaP_[index]);
    setnominaPersonal(nominaP_);
  };

  const calcularSumaValorEntrada3 = (index, value, restaP) => {
    const deuda = parseFloat(restaP) || 0;
    // Permite borrar (""), dejar 0 o escribir monto parcial mientras tipea
    const texto = value === null || value === undefined ? "" : String(value);
    const num = texto.trim() === "" || texto === "." ? 0 : parseFloat(texto);
    if (texto.trim() !== "" && texto !== "." && isNaN(num)) return;
    if (num < 0) return;
    if (num > deuda) return;
    let nominaP_ = Array.from(nominaPersonal);
    nominaP_[index].valorEntrada3 = texto;
    nominaP_[index].variable12 = num;
    nominaP_[index].variable13 = parseFloat(
      (parseFloat(nominaP_[index].variable11) || 0) - num
    ).toFixed(2);
    setnominaPersonal(nominaP_);
  };

  const calcularSumaValorEntrada4 = (
    index,
    value,
    salarioHora,
    tipoC,
    ssop,
    seduP
  ) => {
    let nominaP_ = Array.from(nominaPersonal);
    nominaP_[index].valorEntrada4 = 0;
    nominaP_[index].valorEntrada4 = value;
    console.log(parseFloat(value));
    console.log(nominaP_[index].valorEntrada4);
    // console.log(horasNT)
    //console.log(nominaP_[index].variable2);
    if (parseFloat(value) === 0) value = 0;
    nominaP_[index].variable21 = parseFloat(value * salarioHora).toFixed(2);

    if (tipoC !== "5" && tipoC !== "6") {
      nominaP_[index].variable3 =
        parseFloat(nominaP_[index].variable23) +
        parseFloat(value * salarioHora);
    }
    if (tipoC === "5" || tipoC === "6") {
      nominaP_[index].variable3 =
        parseFloat(nominaP_[index].variable36) *
          parseFloat(nominaP_[index].variable15) +
        parseFloat(nominaP_[index].variable23) +
        parseFloat(value * salarioHora);

      nominaP_[index].variable8 = parseFloat(
        ((nominaP_[index].variable3 -
          nominaP_[index].variable5 -
          nominaP_[index].variable7 -
          nominaP_[index].variable34) *
          ssop) /
          100
      ).toFixed(2);

      nominaP_[index].variable9 = parseFloat(
        ((nominaP_[index].variable3 -
          nominaP_[index].variable5 -
          nominaP_[index].variable7 -
          nominaP_[index].variable34) *
          seduP) /
          100
      ).toFixed(2);

      if (
        nominaP_[index].variable3 -
          nominaP_[index].variable5 -
          nominaP_[index].variable7 -
          nominaP_[index].variable34 >=
        424
      ) {
        nominaP_[index].variable10 = parseFloat(
          ((nominaP_[index].variable3 -
            nominaP_[index].variable5 -
            nominaP_[index].variable7 -
            nominaP_[index].variable34 -
            423.07) *
            15) /
            100
        ).toFixed(2);
      } else {
        nominaP_[index].variable10 = 0;
      }
    }

    aplicarSubtotalYTotalNeto(nominaP_[index]);
    setnominaPersonal(nominaP_);
  };

  const calcularSumaValorEntrada5 = (
    index,
    value,
    horasNT,
    ssop,
    seduP,
    tipoNo
  ) => {
    let nominaP_ = Array.from(nominaPersonal);
    nominaP_[index].variable34 =
      value === "" || value === null || typeof value === "undefined"
        ? 0
        : value;
    aplicarSubtotalYTotalNeto(nominaP_[index]);
    setnominaPersonal(nominaP_);
  };

  const calcularSumaValorEntrada6 = (index, value, ssop, seduP, valorHora) => {
    let nominaP_ = Array.from(nominaPersonal);
    //nominaP_[index].variable34 = 0;
    nominaP_[index].variable36 = value;

    // nominaP_[index].variable8 = parseFloat(
    //   ((nominaP_[index].variable3 -
    //     nominaP_[index].variable5 -
    //     nominaP_[index].variable7 -
    //     nominaP_[index].variable34) *
    //     ssop) /
    //     100
    // ).toFixed(2);
    // nominaP_[index].variable9 = parseFloat(
    //   ((nominaP_[index].variable3 -
    //     nominaP_[index].variable5 -
    //     nominaP_[index].variable7 -
    //     nominaP_[index].variable34) *
    //     seduP) /
    //     100
    // ).toFixed(2);
    // if (tipoNo.substring(0, 4) !== "HONO") {
    //   if (
    //     nominaP_[index].variable3 -
    //       nominaP_[index].variable5 -
    //       nominaP_[index].variable7 -
    //       nominaP_[index].variable34 >=
    //     424
    //   ) {
    //     nominaP_[index].variable10 = parseFloat(
    //       ((nominaP_[index].variable3 -
    //         nominaP_[index].variable5 -
    //         nominaP_[index].variable7 -
    //         nominaP_[index].variable34 -
    //         423.07) *
    //         15) /
    //         100
    //     ).toFixed(2);
    //   } else {
    //     nominaP_[index].variable10 = 0;
    //   }
    // }

    nominaP_[index].variable3 = parseFloat(
      parseFloat(nominaP_[index].variable21) + parseFloat(value * valorHora)
    ).toFixed(0);

    nominaP_[index].variable8 = parseFloat(
      ((nominaP_[index].variable3 -
        nominaP_[index].variable5 -
        nominaP_[index].variable7 -
        nominaP_[index].variable34) *
        ssop) /
        100
    ).toFixed(2);

    nominaP_[index].variable9 = parseFloat(
      ((nominaP_[index].variable3 -
        nominaP_[index].variable5 -
        nominaP_[index].variable7 -
        nominaP_[index].variable34) *
        seduP) /
        100
    ).toFixed(2);

    if (
      nominaP_[index].variable3 -
        nominaP_[index].variable5 -
        nominaP_[index].variable7 -
        nominaP_[index].variable34 >=
      424
    ) {
      nominaP_[index].variable10 = parseFloat(
        ((nominaP_[index].variable3 -
          nominaP_[index].variable5 -
          nominaP_[index].variable7 -
          nominaP_[index].variable34 -
          423.07) *
          15) /
          100
      ).toFixed(2);
    } else {
      nominaP_[index].variable10 = 0;
    }

    aplicarSubtotalYTotalNeto(nominaP_[index]);
    setnominaPersonal(nominaP_);
  };
  const calcularSumaValorEntrada7 = (
    index,
    value,
    salarioDia,
    salarioNeto,
    ssop,
    seduP,
    valorHora
  ) => {
    let nominaP_ = Array.from(nominaPersonal);

    nominaP_[index].variable39 = value;

    nominaP_[index].variable40 = parseFloat(value * salarioDia).toFixed(2);

    let deducciones =
      parseFloat(nominaP_[index].variable5) +
      parseFloat(nominaP_[index].variable7) +
      parseFloat(nominaP_[index].variable34);

    let asignaciones =
      parseFloat(nominaP_[index].variable3) +
      parseFloat(nominaP_[index].variable40);

    nominaP_[index].variable8 = parseFloat(
      ((asignaciones - deducciones) * ssop) / 100
    ).toFixed(2);

    nominaP_[index].variable9 = parseFloat(
      ((parseFloat(nominaP_[index].variable3) +
        parseFloat(nominaP_[index].variable40) -
        parseFloat(nominaP_[index].variable5) -
        parseFloat(nominaP_[index].variable7) -
        parseFloat(nominaP_[index].variable34)) *
        seduP) /
        100
    ).toFixed(2);

    if (
      parseFloat(nominaP_[index].variable3) +
        parseFloat(nominaP_[index].variable38) +
        parseFloat(nominaP_[index].variable40) -
        parseFloat(nominaP_[index].variable5) -
        parseFloat(nominaP_[index].variable7) -
        parseFloat(nominaP_[index].variable34) >=
      424
    ) {
      nominaP_[index].variable10 = parseFloat(
        ((parseFloat(nominaP_[index].variable3) +
          parseFloat(nominaP_[index].variable38) +
          parseFloat(nominaP_[index].variable40) -
          parseFloat(nominaP_[index].variable5) -
          parseFloat(nominaP_[index].variable7) -
          parseFloat(nominaP_[index].variable34) -
          423.07) *
          15) /
          100
      ).toFixed(2);
    } else {
      nominaP_[index].variable10 = 0;
    }

    nominaP_[index].variable11 = parseFloat(
      parseFloat(nominaP_[index].variable3) +
        parseFloat(nominaP_[index].variable38) +
        parseFloat(nominaP_[index].variable40) -
        parseFloat(nominaP_[index].variable5) -
        parseFloat(nominaP_[index].variable7) -
        parseFloat(nominaP_[index].variable34) -
        parseFloat(nominaP_[index].variable8) -
        parseFloat(nominaP_[index].variable9) -
        parseFloat(nominaP_[index].variable10)
    ).toFixed(2);
    const v12 = parseFloat(nominaP_[index].variable12) || 0;
    nominaP_[index].variable13 = (parseFloat(nominaP_[index].variable11) - v12).toFixed(2);

    setnominaPersonal(nominaP_);
  };


  const prioridad = () => {
    console.log("paso");
  };

  const consultaPrestamo = (x) => {
    if (parseFloat(x) > 0) {
      setmensajealerta(true);
      settituloM("Menu Nomina.");
      setcuerpoM("Deuda del Trabajador por Prestamo = " + x);
      buscarNomina();
    } else {
      setmensajealerta(true);
      settituloM("Menu Nomina.");
      setcuerpoM("El trabajador no tiene Prestamo Pendiente");
    }
  };

  const datosBanco = () => {
    if (quincena.length > 0 && mesapagar.length > 0 && anopagar > 0) {
      let form = new FormData();
      form.append("quincena", quincena);
      form.append("mesapagar", mesapagar);
      form.append("anoapagar", anopagar);
      form.append("diaImpresionReporte", opcionImpresionParaReporte());
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteDatosBancarios.php",
        responseType: "arraybuffer",
        data: form,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    } else {
      setmensajealerta(true);
      settituloM("Reporte Datos Bancarios.");
      setcuerpoM("Debe seleccionar la Quincena, mes y año de la Nomina");
    }
  };

  const registroContable = () => {
    if (mesapagar.length > 0 && anopagar > 0) {
      let form = new FormData();
      form.append("mesapagar", mesapagar);
      form.append("anoapagar", anopagar);
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteRegistroContable.php",
        responseType: "arraybuffer",
        data: form,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    } else {
      setmensajealerta(true);
      settituloM("Reporte Registro Codigo Contable.");
      setcuerpoM("Debe seleccionar el Mes y Año.");
    }
  };

  const reporteSalarioAcumulado = () => {
    if (anopagar.length > 0) {
      let data = new FormData();
      data.append("anoapagar", anopagar);
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteSalarioAcumulado.php",
        responseType: "arraybuffer",
        data: data,
      }).then(({ data }) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "ReporteSalarioAcumulado.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    } else {
      setmensajealerta(true);
      settituloM("Salarios Acumulado.");
      setcuerpoM("Debe seleccionar el Año de la Nomina");
    }
  };

  const reporteSipeNuevoExcel = () => {
    if (mesapagar.length > 0 && anopagar > 0) {
      let form = new FormData();
      form.append("mesapagar", mesapagar);
      form.append("anoapagar", anopagar);
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteSipeNuevoExcel.php",
        responseType: "arraybuffer",
        data: form,
      }).then(({ data }) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "ReporteSipeNuevo.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    } else {
      setmensajealerta(true);
      settituloM("Reporte Sipe Nuevo.");
      setcuerpoM("Debe seleccionar el Mes y Año.");
    }
  };

  const empleadoCorreos = () => {
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteEmpleadosCorreo.php",
      responseType: "arraybuffer",
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    });
  };

  const empleadoCorreos2 = () => {
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteEmpleadosSalarios.php",
      responseType: "arraybuffer",
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    });
  };

  const colaboradoresContrato = () => {
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteColaboradoresContrato.php",
      responseType: "arraybuffer",
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    });
  };

  const empleadoSalarioExcel = () => {
    let data = new FormData();
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteEmpleadosSalariosExcel.php",
      responseType: "arraybuffer",
      data: data,
    }).then(({ data }) => {
      const downloadUrl = window.URL.createObjectURL(new Blob([data]));

      const link = document.createElement("a");

      link.href = downloadUrl;

      link.setAttribute("download", "SalariosExcel.xlsx"); //any other extension

      document.body.appendChild(link);

      link.click();

      link.remove();
    });
  };

  const asistencia = () => {
    if (asistenciaOn) {
      setAsistenciaOn(false);
    } else {
      setAsistenciaOn(true);
    }
  };

  const deduc = () => {
    if (deducOn) {
      setDdeducOn(false);
    } else {
      setDdeducOn(true);
    }
  };

  const cuadreNomina = () => {
    if (!quincena || !mesapagar || !anopagar) {
      setmensajealerta(true);
      settituloM("Reporte Cuadre Nomina.");
      setcuerpoM("Debe indicar Quincena, Mes y Año a pagar.");
      return;
    }
    let data = new FormData();
    data.append("anoapagar", anopagar);
    data.append("trimestre", quincena);
    data.append("mesapagar", mesapagar);
    data.append("openvio", openvio);
    data.append("sede", sede);
    data.append("diaImpresionReporte", opcionImpresionParaReporte());
    axios({
      method: "post",
      url: "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteCuadreNomina.php",
      responseType: "arraybuffer",
      data: data,
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    }).catch(() => {
      setmensajealerta(true);
      settituloM("Reporte Cuadre Nomina.");
      setcuerpoM("Error al generar el reporte. Verifique los datos e intente de nuevo.");
    });
  };

  const cierreQ = () => {
    if (cierreQuinOn) {
      setCierreQuinOn(false);
    } else {
      setCierreQuinOn(true);
      buscarCierreQuincenal();
    }
  };

  const cierreQuincena = () => {
    let form = new FormData();
    form.append("quincena", quincena);
    form.append("mes", mesapagar);
    form.append("anio", anopagar);
    form.append("boton", "guardarcierre");
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/cierreQuincenaNomina.php";
    axios.post(xurl, form, config).then((res) => {
      //console.log("paso "+res.data.variable2)
      if (res.data.variable1) {
        setmensajealerta(true);
        settituloM("Cierre de Quincenas Nomina.");
        setcuerpoM(res.data.variable2);
        buscarCierreQuincenal();
      } else {
        setmensajealerta(true);
        settituloM("Cierre de Quincenas Nomina.");
        setcuerpoM(res.data.variable2);
      }
    });
  };

  const eliminarCierre = (e) => {
    let form = new FormData();
    form.append("idcierre", e);
    form.append("boton", "eliminarCierre");
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/cierreQuincenaNomina.php";
    axios.post(xurl, form, config).then((res) => {
      //console.log("paso "+res.data.variable2)
      if (res.data.variable1) {
        setmensajealerta(true);
        settituloM("Cierre de Quincenas Nomina.");
        setcuerpoM(res.data.variable2);
        buscarCierreQuincenal();
      } else {
        setmensajealerta(true);
        settituloM("Cierre de Quincenas Nomina.");
        setcuerpoM(res.data.variable2);
      }
    });
  };
  

  const buscarCierreQuincenal = () => {
    let form = new FormData();
    form.append("boton", "buscarCierres");
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/cierreQuincenaNomina.php";
    axios.post(xurl, form, config).then((res) => {
      //console.log("paso "+res.data.variable2)
      setCierreQui(res.data.variable2);
    });
  };

  const deducExcel = () => {
    let data = new FormData();
    data.append("desde", desde);
    data.append("hasta", hasta);
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteNominaDeducciones.php",
      responseType: "arraybuffer",
      data: data,
    }).then(({ data }) => {
      const downloadUrl = window.URL.createObjectURL(new Blob([data]));

      const link = document.createElement("a");

      link.href = downloadUrl;

      link.setAttribute("download", "Deducciones.xlsx"); //any other extension

      document.body.appendChild(link);

      link.click();

      link.remove();
    });
  };

  const asistenciaExcel = () => {
    let data = new FormData();
    data.append("desde", desde);
    data.append("hasta", hasta);
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteAsistenciaPersonal.php",
      responseType: "arraybuffer",
      data: data,
    }).then(({ data }) => {
      const downloadUrl = window.URL.createObjectURL(new Blob([data]));

      const link = document.createElement("a");

      link.href = downloadUrl;

      link.setAttribute("download", "AsistenciaExcel.xlsx"); //any other extension

      document.body.appendChild(link);

      link.click();

      link.remove();
    });
  };

  const empleadoCodigoContable = () => {
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteEmpleadoCuentaContable.php",
      responseType: "arraybuffer",
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    });
  };

  React.useEffect(() => {
    //console.log(props.cedulaempleado);
    buscarPersonal();
    cargarFechas();
    cargarCuentas();
    fetchSedes().then(setSedes);
  }, []);
  const puedeElegirTipoPago = periodoCrearNominaLleno(
    quincena,
    mesapagar,
    anopagar
  );
  const puedeCrearNomina =
    puedeElegirTipoPago && esOpcionImpresionCrearValida(diaImpresionCrearNomina);
  const mostrarTooltipRegla600 = hayDescuentoOperativoEnNomina(nominaPersonal);
  const tooltipRegla600 = (
    <span className="nomina-tooltip-regla600">{TEXTO_REGLA_600_OPERATIVO}</span>
  );
  return (
    <div className="principal-pago row">
      <div className="contenedor-cxc col-12">
        {/* <div className="titulo-cxc ">
          <p>CREAR NOMINA DE EMPLEADOS. </p>
        </div> */}
        {mensajealerta === true && (
          <Alert
            tituloMensaje={tituloM}
            cuerpoMensaje={cuerpoM}
            open={mensajealerta}
            handleClose={handleClose}
          />
        )}
        {flotadorNOn === true && (
          <div className="flotadorPe">
            <div className="flotadorPe1">
              <ReporteN
                personalClose={activarReporte2}
                diaImpresionReporte={opcionImpresionParaReporte()}
              />
            </div>
          </div>
        )}
        {flotador3NOn === true && (
          <div className="flotadorPe">
            <div className="flotadorPe1">
              <ReporteN2
                personalClose={activarReporte3}
                diaImpresionReporte={opcionImpresionParaReporte()}
              />
            </div>
          </div>
        )}
        {flotador4NOn === true && (
          <div className="flotadorPe">
            <div className="flotadorPe1">
              <ReporteN3
                personalClose={activarReporte4}
                diaImpresionReporte={opcionImpresionParaReporte()}
              />
            </div>
          </div>
        )}

        {flotadorInasistenciaOn === true && (
          <div className="flotadorPe">
            <div className="flotadorPe1">
              <Inasistencia personalClose={activarInasistencia} />
            </div>
          </div>
        )}

        {comprobantesOn === true && (
          <div className="flotadorPe">
            <div className="flotadorPe1">
              <div className="cont-titulomedi col-12">
                <span className="titulocasos">
                  Imprimir comprobantes de pago
                </span>
                <span
                  className="titulo-cerrarcasos"
                  onClick={cerrarComprobantes}
                >
                  X
                </span>
              </div>
              <div className="cont-titulomedi col-12" style={{ backgroundColor: "#f5f5f5", padding: "8px", marginBottom: "10px" }}>
                <span className="titulocasos">
                  {quincena === "1" ? "Primera" : "Segunda"} quincena de {mesapagar && Array.isArray(mes) && mes.find((m) => m.variable1 === mesapagar) ? mes.find((m) => m.variable1 === mesapagar).variable2 : mesapagar} / {anopagar}
                </span>
              </div>
              <div className="cont-personal col-6">
                <label className="titulo-salario2">
                  Imprimir:
                  <select
                    name="diaImpresionReporteComprobante"
                    value={diaImpresionReporte}
                    onChange={(e) => {
                      setDiaImpresionReporte(e.target.value);
                      setEmpleadoComprobante("");
                      if (sedeComprobante) {
                        cargarEmpleadosComprobantes(sedeComprobante);
                      }
                    }}
                  >
                    <option value="">Seleccione opción</option>
                    {OPCIONES_IMPRESION_REPORTE.map((item) => (
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
              <div className="cont-personal col-6">
                <label className="titulo-salario2">
                  Tipo de nómina:
                  <select
                    name="tipoNominaComprobante"
                    value={tipoNominaComprobante}
                    onChange={onChangeTipoNominaComprobante}
                  >
                    <option value="">Seleccione tipo</option>
                    <option value="todos">Todos</option>
                    <option value="sinHonorarios">Sin Honorarios</option>
                    <option value="conHonorarios">Con Honorarios</option>
                  </select>
                </label>
              </div>
              <div className="cont-personal col-6">
                <label className="titulo-salario2">
                  Quincena: {quincena} | Mes: {mesapagar} | Año: {anopagar}
                </label>
              </div>
              <div className="cont-personal col-6">
                <label className="titulo-salario2">
                  Sede:
                  <select
                    name="sedeComprobante"
                    value={sedeComprobante}
                    onChange={onChangeSedeComprobante}
                    disabled={!tipoNominaComprobante}
                  >
                    <option value="">{tipoNominaComprobante ? "Seleccione sede" : "Seleccione tipo primero"}</option>
                    {sedes.map((s, i) => (
                      <option key={i} value={s.variable1}>
                        {s.variable2}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
              <div className="cont-personal col-6">
                <label className="titulo-salario2">
                  Empleado:
                  <select
                    name="empleadoComprobante"
                    value={empleadoComprobante}
                    onChange={(e) => setEmpleadoComprobante(e.target.value)}
                    disabled={!sedeComprobante}
                  >
                    <option value="todos">{sedeComprobante ? "Todos" : "Seleccione sede primero"}</option>
                    {nominaPersonalComprobantes.map((item, i) => (
                      <option key={i} value={item.variable20}>
                        {item.variable2 + (item.variable3 ? " - " + item.variable3 : "")}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
              <div className="cont-listmedi row">
                <div className="cont-personal col-3">
                  <button className="boton" onClick={imprimirComprobantes}>
                    Imprimir
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {flotador2NOn === true && (
          <div className="flotadorPe">
            <div className="flotadorPe1">
              <div className="cont-titulomedi col-12">
                <span className="titulocasos">
                  Adicionar Trabajador a la Nomina
                </span>
                <span
                  className="titulo-cerrarcasos"
                  onClick={() => {
                    adicionarTra();
                  }}
                >
                  X
                </span>
              </div>

              <div className="cont-personal col-4">
                <label className="titulo-salario2">
                  Seleccione un Empleado.
                  <select
                    id="cedulaNomina"
                    name="cedulaNomina"
                    value={
                      typeof data.cedulaNomina !== "undefined"
                        ? data.cedulaNomina
                        : ""
                    }
                    onChange={onChange}
                  >
                    <option value="0">-- Seleccione Empleado --</option>
                    {personal.map((item, i) => {
                      return (
                        <option key={i} value={item.variable1}>
                          {item.variable2 + " ==> " + item.variable3}
                        </option>
                      );
                    })}
                  </select>
                </label>
              </div>
              <div className="cont-listmedi row">
                <div className="cont-personal col-3">
                  <button className="boton" onClick={guardarNominaInd}>
                    Crear Nomina
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {asistenciaOn === true && (
          <div className="flotadorPe">
            <div className="flotadorPe1">
              <div className="cont-titulomedi col-12">
                <span className="titulo-asistencia">
                  Reporte Asistencia Personal
                </span>
                <span
                  className="titulo-cerrarcasos"
                  onClick={() => {
                    asistencia();
                  }}
                >
                  X
                </span>
              </div>

              <div className="cont-personal col-3">
                <label className="titulo-asistencia">
                  Fecha desde.
                  <input
                    className="form-control"
                    type="date"
                    name="desde"
                    id="desde"
                    autoComplete="off"
                    // placeholder="Hora Entrada 07:00"
                    // maxLength="5"
                    onChange={onChange1}
                    value={desde}
                  />
                </label>
              </div>
              <div className="cont-personal col-3">
                <label className="titulo-asistencia">
                  Fecha Hasta.
                  <input
                    className="form-control"
                    type="date"
                    name="hasta"
                    id="hasta"
                    autoComplete="off"
                    // placeholder="Hora de Salida 12:00"
                    // maxLength="5"
                    onChange={onChange2}
                    value={hasta}
                  />
                </label>
              </div>
              <div className="cont-listmedi row">
                <div className="cont-personal col-3">
                  <button className="boton" onClick={asistenciaExcel}>
                    Imprimir
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {cierreQuinOn === true && (
          <div className="flotadorPe">
            <div className="flotadorPe1">
              <div className="cont-titulomedi col-12">
                <span className="titulo-asistencia">
                  Menu Cierre Quincenal de Nomina
                </span>
                <span
                  className="titulo-cerrarcasos"
                  onClick={() => {
                    cierreQ();
                  }}
                >
                  X
                </span>
              </div>
              <div className="cont-personal col-12">
                <select
                  id="quincena"
                  name="quincena"
                  value={typeof quincena !== "undefined" ? quincena : ""}
                  onChange={onChange}
                >
                  <option value="0">Seleccione Quincena</option>
                  <option value="1">Primera Quincena.</option>
                  <option value="2">Segunda Quincena.</option>
                </select>
                <span id="separar"></span>

                <select
                  id="mesapagar"
                  name="mesapagar"
                  value={typeof mesapagar !== "undefined" ? mesapagar : ""}
                  onChange={onChange}
                >
                  <option value="0">Mes a Pagar</option>
                  {mes.map((item, i) => {
                    return (
                      <option key={i} value={item.variable1}>
                        {item.variable2}
                      </option>
                    );
                  })}
                </select>
                <span id="separar"></span>
                <select
                  id="anopagar"
                  name="anopagar"
                  value={typeof anopagar !== "undefined" ? anopagar : ""}
                  onChange={onChange}
                >
                  <option value="0">Año a Pagar</option>
                  {anio.map((item, i) => {
                    return (
                      <option key={i} value={item.variable1}>
                        {item.variable1}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="cont-listmedi row">
                <div className="cont-personal col-3">
                  <button className="boton" onClick={cierreQuincena}>
                    Guardar Cierre
                  </button>
                </div>
              </div>
              <div className="cont-listnomi row">
                <div className="listnomi col-12">
                  <table className="tablanomi" border="1">
                    <thead className="theadcreartabla">
                      <tr className="trcreartabla">
                        <th className="xtitunomina2">Quincena.</th>
                        <th className="xtitunomina2">Mes Cerrado.</th>
                        <th className="xtitunomina1">
                          <span className="cerrarme3"></span>
                        </th>
                      </tr>
                    </thead>

                    <tbody className="evocuerpo1">
                      {cierreQui.map((item, i) => {
                        return (
                          <tr
                            className="odd1"
                            key={item.variable1}
                            id={item.variable1}
                          >
                            <td
                              className="nombrePersonal"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable2}
                            </td>
                            <td
                              className="nombrePersonal"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable3}
                            </td>
                            <td width="20">
                              
                                <span
                                  className="cerrarme1"
                                  onClick={() => {
                                    eliminarCierre(item.variable1);
                                  }}
                                ></span>
                              
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        {deducOn === true && (
          <div className="flotadorPe">
            <div className="flotadorPe1">
              <div className="cont-titulomedi col-12">
                <span className="titulo-asistencia">
                  Reporte Deducciones Personal
                </span>
                <span
                  className="titulo-cerrarcasos"
                  onClick={() => {
                    deduc();
                  }}
                >
                  X
                </span>
              </div>

              <div className="cont-personal col-3">
                <label className="titulo-asistencia">
                  Fecha desde.
                  <input
                    className="form-control"
                    type="date"
                    name="desde"
                    id="desde"
                    autoComplete="off"
                    // placeholder="Hora Entrada 07:00"
                    // maxLength="5"
                    onChange={onChange1}
                    value={desde}
                  />
                </label>
              </div>
              <div className="cont-personal col-3">
                <label className="titulo-asistencia">
                  Fecha Hasta.
                  <input
                    className="form-control"
                    type="date"
                    name="hasta"
                    id="hasta"
                    autoComplete="off"
                    // placeholder="Hora de Salida 12:00"
                    // maxLength="5"
                    onChange={onChange2}
                    value={hasta}
                  />
                </label>
              </div>
              <div className="cont-listmedi row">
                <div className="cont-personal col-3">
                  <button className="boton" onClick={deducExcel}>
                    Imprimir
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {prioridadOn && (
          <div className="cont-tablanomina row">
            <div className="tablanomina1 col-7">
              <div className="cont-titulomedi col-12">
                <span className="titulocasos">
                  Prioridad de Pago a la {quincena} Quincena {mesapagar}-
                  {anopagar}
                </span>
                <span
                  className="titulo-cerrarcasos"
                  onClick={() => {
                    cerrarPrioridad();
                  }}
                >
                  X
                </span>
              </div>
              <div className="cont-titulomedi col-12">
                <span className="titulocasos">
                  Monto Seleccionado{" "}
                  <span className="titulocasos1">
                    {totalPrioridad.toFixed(2)}
                  </span>{" "}
                  Monto Pagado{" "}
                  <span className="titulocasos1">
                    {totalPrioridadPagada.toFixed(2)}
                  </span>{" "}
                  Monto Por Pagar{" "}
                  <span className="titulocasos1">
                    {totalPrioridadPP.toFixed(2)}
                  </span>
                </span>
              </div>
              <span className="titulo-nomina"></span>

              <div className="cont-listnomi row">
                <div className="listnomi col-12">
                  <table className="tablanomi" border="1">
                    <thead className="theadcreartabla">
                      <tr className="trcreartabla">
                        <th className="xtitunomina2">Nombre Empleado.</th>
                        <th className="xtitunomina2">Tipo Nomina.</th>
                        <th className="xtitunomina3">Total a Pagar.</th>
                        <th className="xtitunomina3">Cargo.</th>
                        <th className="xtitunomina1">Prioridad.</th>
                        <th className="xtitunomina1">Pagado.</th>
                      </tr>
                    </thead>

                    <tbody className="evocuerpo1">
                      {nominaPersonal.map((item, i) => {
                        return (
                          <tr
                            className={
                              item.variable30 === "COLABO. C/DEDU. DEFI. ADM."
                                ? "odd1"
                                : item.variable30 ===
                                  "COLABO. C/DEDU. DEFI. DOCENTE."
                                ? "odd2"
                                : item.variable30 ===
                                  "COLABO. C/DEDU. DEFI. H/PROFE."
                                ? "odd3"
                                : item.variable30 ===
                                  "COLABO. C/DEDU. INDEFI. ADM."
                                ? "odd4"
                                : item.variable30 ===
                                  "COLABO. C/DEDU. INDEFI. DOCENTE."
                                ? "odd5"
                                : item.variable30 ===
                                  "COLABO. C/DEDU. INDEFI. H/PROFE."
                                ? "odd6"
                                : item.variable30 === "HONO. PROFE. ADM."
                                ? "odd7"
                                : item.variable30 === "HONO. PROFE. DOCENTE."
                                ? "odd8"
                                : item.variable30 === "HONO. PROFESIONALES."
                                ? "odd9"
                                : item.variable30 ===
                                  "CONTRATO POR HORA DEFINIDO."
                                ? "odd10"
                                : item.variable30 ===
                                  "CONTRATO POR HORA DEFINIDO ADM."
                                ? "odd10"
                                : item.variable30 ===
                                  "CONTRATO POR HORA INDEFINIDO ADM."
                                ? "odd10"
                                : item.variable30 ===
                                  "CONTRATO POR HORA INDEFINIDO OPER."
                                ? "odd10"
                                : ""
                            }
                            key={item.variable1}
                            id="tabla"
                          >
                            <td
                              className="nombrePersonal"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable2}
                            </td>
                            <td
                              className="nombrePersonal"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable30}
                            </td>
                            <td
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable13}
                            </td>
                            <td
                              className="cargoo"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable31}
                            </td>

                            <td width="20">
                              {item.variable33 !== "SI" ? (
                                <input
                                  type="radio"
                                  className="opvacunacionsi"
                                  name={item.variable1}
                                  id={item.variable1}
                                  value="A"
                                  checked={item.variable32 === "A"}
                                  onClick={() => {
                                    onChange4(item.variable20, item.variable1);
                                  }}
                                />
                              ) : (
                                <span className="pagado">Pagado</span>
                              )}
                            </td>
                            <td width="20">
                              {item.variable32 === "A" && (
                                <input
                                  type="radio"
                                  className="pagadosi"
                                  name={item.variable1}
                                  id={item.variable1}
                                  value="SI"
                                  checked={item.variable33 === "SI"}
                                  onClick={() => {
                                    onChange5(item.variable20, item.variable1);
                                  }}
                                />
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        {listaOn && (
          <div className="cont-tablanomina row">
            <div className="tablanomina1 col-7">
              <div className="cont-titulomedi col-12">
                <span className="titulocasos">
                  Nomina Creada a la {quincena} Quincena {mesapagar}-{anopagar}
                </span>
                <span
                  className="titulo-cerrarcasos"
                  onClick={() => {
                    cerrarLista();
                  }}
                >
                  X
                </span>
                <div className="cont-listmedi row">
                  <div className="cont-personal col-3">
                    <select
                      id="sede"
                      name="sede"
                      value={typeof sede !== "undefined" ? sede : ""}
                      onChange={onChange}
                    >
                      <option value="">-Seleccione Sucursal-</option>
                      {sedes.map((item) => (
                        <option key={item.variable1} value={String(item.variable1)}>
                          {item.variable2}
                        </option>
                      ))}
                      <option value="0">Todas</option>
                    </select>
                  </div>
                  <div className="cont-personal col-3">
                    <label className="titulo-salario2">
                      Imprimir:
                      <select
                        id="diaImpresionReporteConsulta"
                        name="diaImpresionReporteConsulta"
                        value={diaImpresionReporteConsulta}
                        onChange={onChangeImpresionConsulta}
                      >
                        <option value="">Seleccione opción</option>
                        {OPCIONES_IMPRESION_REPORTE.map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                        <option value="4">Opción 4 (Todas)</option>
                      </select>
                    </label>
                  </div>
                  {!cierreOn && (
                    <div className="cont-personal col-2">
                      <button className="boton" onClick={actualizarNomina}>
                        Actualizar Nomina
                      </button>
                    </div>
                  )}
                  {!cierreOn && (
                    <div className="cont-personal col-2">
                      <button className="boton" onClick={adicionarTra}>
                        Adicionar Trabajador a la Nomina
                      </button>
                    </div>
                  )}
                  <div className="cont-personal col-2">
                    {ocultarOn === false && (
                      <button className="boton" onClick={ocultarCuentas}>
                        Ocultar Cuentas
                      </button>
                    )}
                    {ocultarOn === true && (
                      <button className="boton" onClick={ocultarCuentas}>
                        Mostrar Cuentas
                      </button>
                    )}
                  </div>
                  {!cierreOn && (
                    <div className="cont-personal col-2">
                      <button className="boton" onClick={confirmarEliminarQuincena}>
                        Eliminar Quincena
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <span className="titulo-nomina"></span>

              <div className="cont-listnomi row">
                <div className="listnomi col-12">
                  <table className="tablanomi tablanomi-nomina-creada" border="1">
                    <thead className="theadcreartabla">
                      <tr className="trcreartabla">
                        <th className="xtitunomina1 nomina-creada-col-no">No.</th>
                        <th className="xtitunomina-nombre-empleado nomina-creada-col-nombre">
                          Nombre Empleado.
                        </th>
                        <th className="xtitunomina1">horas.</th>
                        <th className="xtitunomina1">$/Hora.</th>
                        <th className="xtitunomina1">H/Ext.</th>
                        <th className="xtitunomina1">Monto H/E.</th>
                        <th className="xtitunomina3">S.Quin.</th>
                        <th className="xtitunomina-prima-produ">Prima Produ.</th>
                        {/*<th className="xtitunomina1">Dias Pag/Inc.</th>
                        <th className="xtitunomina-monto-pag-inc">Monto Pag/Inc.</th>*/}

                        <th className="xtitunomina1">Dias N/T.</th>
                        <th className="xtitunomina1">
                          {mostrarTooltipRegla600 ? (
                            <Tooltip title={tooltipRegla600} arrow placement="top">
                              <span className="nomina-th-ayuda">Monto D/N/T.</span>
                            </Tooltip>
                          ) : (
                            "Monto D/N/T."
                          )}
                        </th>
                        <th className="xtitunomina1">Horas N/T.</th>
                        <th className="xtitunomina1">
                          {mostrarTooltipRegla600 ? (
                            <Tooltip title={tooltipRegla600} arrow placement="top">
                              <span className="nomina-th-ayuda">Monto H/N/T.</span>
                            </Tooltip>
                          ) : (
                            "Monto H/N/T."
                          )}
                        </th>
                        <th className="xtitunomina1">S.S.O.</th>
                        <th className="xtitunomina1">S.Edu.</th>
                        <th className="xtitunomina1">I.S.L.R.</th>

                        <th className="xtitunomina1">O./Deducc.</th>
                        {ocultarOn === false && (
                          <th className="xtitunomina1">Cuenta</th>
                        )}
                        <th className="xtitunomina3">Sub-Total.</th>
                        <th className="xtitunomina3">Monto P.</th>
                        <th className="xtitunomina3 nomina-col-ppres">P.Pres.</th>
                        <th className="xtitunomina3">Total a Pagar.</th>
                        <th className="xtitunomina3">Cargo.</th>
                        <th className="xtitunomina1">
                          <span className="cerrarme3"></span>
                        </th>
                      </tr>
                    </thead>

                    <tbody className="evocuerpo1">
                      {nominaPersonal.map((item, i) => {
                        return (
                          <tr
                            className={
                              item.variable30 === "COLABO. C/DEDU. DEFI. ADM."
                                ? "odd1"
                                : item.variable30 ===
                                  "COLABO. C/DEDU. DEFI. DOCENTE."
                                ? "odd2"
                                : item.variable30 ===
                                  "COLABO. C/DEDU. DEFI. H/PROFE."
                                ? "odd3"
                                : item.variable30 ===
                                  "COLABO. C/DEDU. INDEFI. ADM."
                                ? "odd4"
                                : item.variable30 ===
                                  "COLABO. C/DEDU. INDEFI. DOCENTE."
                                ? "odd5"
                                : item.variable30 ===
                                  "COLABO. C/DEDU. INDEFI. H/PROFE."
                                ? "odd6"
                                : item.variable30 === "HONO. PROFE. ADM."
                                ? "odd7"
                                : item.variable30 === "HONO. PROFE. DOCENTE."
                                ? "odd8"
                                : item.variable30 === "HONO. PROFESIONALES."
                                ? "odd9"
                                : item.variable30 ===
                                  "CONTRATO POR HORA DEFINIDO."
                                ? "odd10"
                                : item.variable30 ===
                                  "CONTRATO POR HORA DEFINIDO ADM."
                                ? "odd10"
                                : item.variable30 ===
                                  "CONTRATO POR HORA INDEFINIDO ADM."
                                ? "odd10"
                                : item.variable30 ===
                                  "CONTRATO POR HORA INDEFINIDO OPER."
                                ? "odd10"
                                : ""
                            }
                            key={item.variable1}
                            id="tabla"
                          >
                            {/* <td
                              width="20"
                              onClick={() => {
                                consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable1}
                            </td> */}
                            <td className="nomina-creada-col-no">{i + 1}</td>
                            <td
                              className="xtitunomina-nombre-empleado nomina-creada-col-nombre"
                              id="nombrePersonal"
                              style={{ width: '200px', minWidth: '200px', maxWidth: '200px' }}                            
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable2 + " - " + item.variable30}
                            </td>
                            <td
                              className="contenedorcedulaNomi"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable41}
                            </td>
                            
                            <td
                              className="contenedorcedulaNomi"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable15}
                            </td>
                            <td width="20">
                              {parseFloat(item.variable22) === 0 ? (
                                <div className="contenedorcedulaNomi col-12">
                                  <input
                                    className="form-control"
                                    type="text"
                                    name={item.variable1}
                                    id="horasE"
                                    autoComplete="off"
                                    step="any"
                                    onChange={(e) =>
                                      calcularSumaValorEntrada4(
                                        i,
                                        e.target.value,
                                        item.variable15,
                                        item.variable37,
                                        item.variable28,
                                        item.variable29
                                      )
                                    }
                                    //value={item.valorEntrada}
                                    value={
                                      parseFloat(item.variable21) > 0
                                        ? item.valorEntrada4
                                        : ""
                                    }
                                  />
                                </div>
                              ) : (
                                item.variable27
                              )}
                            </td>
                            <td
                              className="contenedorcedulaNomi"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable21}
                            </td>
                            <td
                              className="contenedorcedulaNomi"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable3}
                            </td>

                          {/* //LO NUEVO DESDE AQUI */}

                            <td
                              className="contenedorcedulaNomi"
                              style={{ width: '60px', minWidth: '60px', maxWidth: '60px' }}
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable38 != null && item.variable38 !== '' && !isNaN(parseFloat(item.variable38))
                                ? parseFloat(item.variable38).toFixed(2)
                                : item.variable38}
                            </td>

                            {/*<td
                              className="contenedorcedulaNomi"
                              width="20"
                              // onClick={() => {
                              //   consultaRecibo(item.variable1);
                              // }}
                            >
                              <div className="contenedorcedula col-12">
                                <input
                                  className="form-control"
                                  type="text"
                                  name={item.variable1}
                                  id="horasE"
                                  autoComplete="off"
                                  step="any"
                                  // readOnly={
                                  //   item.variable37 === "5" ? "readonly" : ""
                                  // }
                                  onChange={(e) =>
                                    calcularSumaValorEntrada7(
                                      i,
                                      e.target.value,
                                      item.variable14,
                                      item.variable8,
                                      item.variable28,
                                      item.variable29,
                                      item.variable30
                                    )
                                  }
                                  //value={item.valorEntrada}
                                  value={
                                    parseFloat(item.variable39) > 0
                                      ? item.variable39
                                      : ""
                                  }
                                />
                              </div>
                            </td>
                            <td
                              className="contenedorcedulaNomi"
                              id="inca"
                              style={{ width: '60px', minWidth: '60px', maxWidth: '60px' }}
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable40}
                            </td> */}

                            {/* //HASTA AQUI */}


                            <td
                              className="contenedorcedulaNomi"
                              width="20"
                              // onClick={() => {
                              //   consultaRecibo(item.variable1);
                              // }}
                            >
                              {parseFloat(item.variable17) === 0 ? (
                                <div className="contenedorcedula col-12">
                                  <input
                                    className="form-control"
                                    type="text"
                                    name={item.variable1}
                                    id="horasE"
                                    autoComplete="off"
                                    step="any"
                                    readOnly="readonly"
                                    onChange={(e) =>
                                      calcularSumaValorEntrada1(
                                        i,
                                        e.target.value,
                                        item.variable55 != null &&
                                          item.variable55 !== ""
                                          ? item.variable55
                                          : item.variable14,
                                        item.variable28,
                                        item.variable29,
                                        item.variable30
                                      )
                                    }
                                    //value={item.valorEntrada}
                                    value={
                                      parseFloat(item.variable5) > 0
                                        ? item.valorEntrada1
                                        : ""
                                    }
                                  />
                                </div>
                              ) : (
                                item.variable25
                              )}
                            </td>
                            <td
                              className="contenedorcedulaNomi"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable5}
                            </td>

                            <td
                              className="contenedorcedulaNomi"
                              style={{ width: '60px', minWidth: '60px', maxWidth: '60px' }}
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable6}
                            </td>
                            
                            <td
                              className="contenedorcedulaNomi"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable7}
                            </td>
                            <td
                              className="contenedorcedulaNomi"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable8}
                            </td>
                            <td
                              className="contenedorcedulaNomi"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable9}
                            </td>
                            <td
                              className="contenedorcedulaNomi"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable10}
                            </td>
                            <td
                              className="contenedorcedulaNomi nomina-col-otros-deducc"
                              // onClick={() => {
                              //   consultaRecibo(item.variable1);
                              // }}
                            >
                              <div className="contenedorcedula col-12">
                                <input
                                  className="form-control nomina-input-otros-deducc"
                                  type="text"
                                  name={item.variable1}
                                  id="otrosEgresos"
                                  autoComplete="off"
                                  step="any"
                                  // readOnly={
                                  //   item.variable37 === "5" ? "readonly" : ""
                                  // }
                                  onChange={(e) =>
                                    calcularSumaValorEntrada5(
                                      i,
                                      e.target.value,
                                      item.variable15,
                                      item.variable28,
                                      item.variable29,
                                      item.variable30
                                    )
                                  }
                                  value={
                                    item.variable34 !== "" &&
                                    item.variable34 != null &&
                                    !isNaN(parseFloat(item.variable34))
                                      ? item.variable34
                                      : ""
                                  }
                                />
                              </div>
                            </td>
                            {ocultarOn === false && (
                              <td
                                className="contenedorcedulaNomi"
                                width="20"
                                // onClick={() => {
                                //   consultaRecibo(item.variable1);
                                // }}
                              >
                                {parseFloat(item.variable34) > 0 ? (
                                  <div className="contenedorcedula col-12">
                                    <select
                                      id={item.variable1}
                                      name={item.variable1}
                                      value={
                                        item.variable35 !== ""
                                          ? item.variable35
                                          : ""
                                      }
                                      //onChange={onChange6}
                                      onChange={(e) =>
                                        onChange6(i, e.target.value)
                                      }
                                    >
                                      <option>Cuenta Contable</option>

                                      {cuenta.map((item, i) => {
                                        return (
                                          <option
                                            key={i}
                                            value={item.variable2}
                                          >
                                            {item.variable6 +
                                              " - " +
                                              item.variable3}{" "}
                                          </option>
                                        );
                                      })}
                                    </select>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </td>
                            )}

                            <td
                              className="contenedorcedulaNomi"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable11}
                            </td>
                            <td
                              className="contenedorcedulaNomi"
                              width="20"
                              onClick={() => {
                                consultaPrestamo(item.variable16);
                              }}
                              title="Saldo pendiente del préstamo"
                            >
                              {parseFloat(item.variable16) > 0
                                ? item.variable16
                                : ""}
                            </td>
                            <td className="contenedorcedulaNomi nomina-col-ppres">
                              {item.prestamoEditable === true &&
                              parseFloat(item.variable16) > 0 &&
                              parseFloat(item.variable19) === 0 ? (
                                <div className="contenedorcedulaNomi col-12">
                                  <input
                                    className="form-control nomina-input-ppres"
                                    type="text"
                                    name={"ppres-" + item.variable1}
                                    id={"ppres-" + item.variable1}
                                    autoComplete="off"
                                    title="Monto a descontar quincenal (cuota). Puede cambiarlo o dejarlo en 0."
                                    onChange={(e) =>
                                      calcularSumaValorEntrada3(
                                        i,
                                        e.target.value,
                                        item.variable16
                                      )
                                    }
                                    value={
                                      item.valorEntrada3 !== undefined &&
                                      item.valorEntrada3 !== null
                                        ? String(item.valorEntrada3)
                                        : ""
                                    }
                                  />
                                </div>
                              ) : parseFloat(item.variable12) > 0 ? (
                                item.variable12
                              ) : (
                                ""
                              )}
                            </td>
                            <td
                              className="contenedorcedulaNomi"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable13}
                            </td>
                            <td
                              className="cargoo"
                              width="20"
                              onClick={() => {
                                //consultaRecibo(item.variable1);
                              }}
                            >
                              {item.variable31}
                            </td>

                            <td width="20">
                              {!cierreOn && (
                                <span
                                  className="cerrarme1"
                                  onClick={() => {
                                    eliminarNomina(item.variable1);
                                  }}
                                ></span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="cont-listmedi row">
          <div className="cont-personal col-3">
            <label className="titulo-salario2">
              Quincena a Pagar.
              <select
                id="quincena"
                name="quincena"
                value={typeof quincena !== "undefined" ? quincena : ""}
                onChange={onChange}
              >
                <option value="0">Seleccione Quincena</option>
                <option value="1">Primera Quincena.</option>
                <option value="2">Segunda Quincena.</option>
              </select>
            </label>
          </div>
          <div className="cont-personal col-2">
            <label className="titulo-salario2">
              Mes a Pagar.
              <select
                id="mesapagar"
                name="mesapagar"
                value={typeof mesapagar !== "undefined" ? mesapagar : ""}
                onChange={onChange}
              >
                <option value="0">Mes a Pagar</option>
                {mes.map((item, i) => {
                  return (
                    <option key={i} value={item.variable1}>
                      {item.variable2}
                    </option>
                  );
                })}
              </select>
            </label>
          </div>
          <div className="cont-personal col-2">
            <label className="titulo-salario2">
              Año a Pagar.
              <select
                id="anopagar"
                name="anopagar"
                value={typeof anopagar !== "undefined" ? anopagar : ""}
                onChange={onChange}
              >
                <option value="0">Año a Pagar</option>
                {anio.map((item, i) => {
                  return (
                    <option key={i} value={item.variable1}>
                      {item.variable1}
                    </option>
                  );
                })}
              </select>
            </label>
          </div>
          <div className="cont-personal col-3">
            <label className="titulo-salario2">
              Tipo de pago.
              <select
                id="diaImpresionCrearNomina"
                name="diaImpresionCrearNomina"
                value={diaImpresionCrearNomina}
                disabled={!puedeElegirTipoPago}
                onChange={(e) => setDiaImpresionCrearNomina(e.target.value)}
              >
                <option value="">Seleccione opción</option>
                {OPCIONES_IMPRESION_CREAR.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>
        <div className="cont-listmedi row">
          <div className="cont-personal col-3">
            <button
              className={puedeCrearNomina ? "boton" : "botoncp"}
              disabled={!puedeCrearNomina}
              onClick={puedeCrearNomina ? guardarNomina : undefined}
            >
              Crear Nomina
            </button>
          </div>
          <div className="cont-listmedi row">
            <div className="titulo-cxc2 col-10 ">
              <p className="confi">CONSULTAS Y REPORTES. </p>
            </div>
          </div>
        </div>
        <div className="contenedorcedula1 col-12">
          {/* <button
            className={!activarOn ? "boton" : "botoncp"}
            onClick={!activarOn ? guardarNomina : ""}
          >
            Crear Nomina
          </button> */}
          <button
            className={!activarOn ? "boton" : "botoncp"}
            onClick={!activarOn ? cerrarLista : ""}
          >
            Consultar Nomina
          </button>
          <div className="cont-personal col-3" style={{ display: "inline-block", verticalAlign: "middle", marginRight: "10px" }}>
            <label className="titulo-salario2">
              Imprimir:
              <select
                id="diaImpresionReporte"
                name="diaImpresionReporte"
                value={diaImpresionReporte}
                onChange={(e) => setDiaImpresionReporte(e.target.value)}
              >
                <option value="">Seleccione opción</option>
                {OPCIONES_IMPRESION_REPORTE.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </label>
          </div>
          <div className="contenedor-select-reportes">
            <label className="label-reportes-nomina">Reportes:</label>
            <select
              id="reporteSeleccionado"
              name="reporteSeleccionado"
              value={reporteSeleccionado}
              onChange={onChangeReporte}
              className="select-reportes-nomina"
            >
              <option value="">Seleccione un Reporte</option>
              <option value="reporteQuincenal">Reporte Quincenal</option>
              {props.usuario1.nivel !== "10" && (
                <option value="reporteQuincenalPago">
                  Reporte Quincenal de Pago
                </option>
              )}
              {props.usuario1.nivel !== "10" && (
                <option value="reportePrioridadPago">
                  Reporte Prioridad Pago
                </option>
              )}
              <option value="reporteDatosBancarios">Reporte Datos Bancarios</option>
              <option value="reporteSipe">Reporte SIPE</option>
              <option value="reporteSipeNuevo">Reporte Sipe Nuevo</option>
              <option value="reporteSalarioAcumulado">Salarios Acumulado</option>
              <option value="reporteEmplCodContable">
                Reporte Empleados Codigo Contable
              </option>
              <option value="reporteEmplCorreo">
                Reporte Empleados Correos
              </option>
              <option value="reporteEmplSalario">
                Reporte Empleados Salarios
              </option>
              <option value="reporteColaboradoresContrato">
                Colaboradores X Contrato
              </option>
              <option value="reporteEmplSalarioExcel">
                Reporte Empleados Salarios Excel
              </option>
              <option value="reporteAsistenciaExcel">
                Reporte Asistencia Empleados Excel
              </option>
              <option value="reporteDeduccionesExcel">
                Reporte Deducciones Nomina Excel
              </option>
              <option value="reporteCuadreNomina">
                Reporte Cuadre Nomina
              </option>
            </select>
          </div>
          {props.usuario1.nivel !== "10" && (
            <button
              className={!activarOn ? "boton" : "botoncp"}
              onClick={!activarOn ? cerrarPrioridad : ""}
            >
              Crear Prioridad Pago
            </button>
          )}
          <button className="boton" onClick={limpiar}>
            Limpiar Datos
          </button>
          <button className="boton" onClick={abrirComprobantes}>
            Imprimir comprobantes de pago
          </button>
          <button className="boton" onClick={cierreQ}>
            Cierre Quincena
          </button>
          <button className="boton" onClick={activarInasistencia}>
            Inasistencia
          </button>
          <button className="boton" onClick={props.personalClose}>
            Salir
          </button>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    token: state.token,
  };
};
export default connect(mapStateToProps)(NominaC);
